import { render, staticRenderFns } from "./inviteTel.vue?vue&type=template&id=708cf6c7&"
import script from "./inviteTel.vue?vue&type=script&lang=js&"
export * from "./inviteTel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports